(function () {
  'use strict';

  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') {
        return E.sdk.getPriceTestManager();
      }
    } catch (_) {}
    return null;
  }

  // VARIANT CHANGE — Bareline/Dawn uses pubsub.js, not DOM CustomEvent.
  // PUB_SUB_EVENTS.variantChange = 'variant-change' (constants.js).
  // Payload shape: { data: { sectionId, html, variant } }
  // variant.id is the newly selected variant's numeric ID.
  // product-info carries data-section + data-product-id — use those to resolve
  // which product changed so we can stamp data-variant-id and call the SDK.
  function onVariantChange(event) {
    var d = event && event.data;
    if (!d || !d.variant || !d.variant.id) return;

    var variantId = String(d.variant.id);
    var sectionId = d.sectionId;

    // Resolve the <product-info> that changed. Scope to the custom element so a
    // generic [data-section] wrapper (which has no data-product-id) can't match
    // first. sectionId is `originalSection || section`, so try both attributes;
    // fall back to the sole product-info on a typical PDP.
    var productInfo = null;
    if (sectionId) {
      productInfo =
        document.querySelector('product-info[data-section="' + sectionId + '"]') ||
        document.querySelector('product-info[data-original-section="' + sectionId + '"]');
    }
    if (!productInfo) {
      var all = document.querySelectorAll('product-info[data-product-id]');
      if (all.length === 1) productInfo = all[0];
    }

    var productId = productInfo && productInfo.getAttribute('data-product-id');

    if (productId) {
      // Keep data-variant-id current on all containers for this product so the
      // engine's isContainerForProduct check passes on the next scan.
      document.querySelectorAll('[data-product-id="' + productId + '"]').forEach(function (el) {
        el.setAttribute('data-variant-id', variantId);
      });

      var mgr = getManager();
      if (mgr && typeof mgr.updatePricesForProduct === 'function') {
        try { mgr.updatePricesForProduct(productId, variantId); return; } catch (_) {}
      }
    }

    // Fallback: couldn't resolve the product (or the targeted call threw) —
    // rescan the whole page so the test price is re-applied after the morph.
    var mgr2 = getManager();
    if (mgr2 && typeof mgr2.updatePricesOnCurrentPage === 'function') {
      try { mgr2.updatePricesOnCurrentPage(); } catch (_) {}
    }
  }

  // pubsub.js loads deferred — subscribe once it's available.
  function trySubscribe() {
    if (typeof subscribe === 'function') {
      subscribe('variant-change', onVariantChange);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        if (typeof subscribe === 'function') {
          subscribe('variant-change', onVariantChange);
        }
      });
    }
  }

  // DOM RE-RENDERS — two cases need a rescan:
  //   1. AJAX cards (recommendations / predictive search / upsell) inject new
  //      [data-product-id] nodes.
  //   2. PDP variant change replaces the #price-<section> innerHTML with fresh
  //      original-price markup. That morph adds .price nodes (NOT [data-product-id]),
  //      so we must watch for price nodes too — this is what makes the price hold
  //      after a variant switch even if the pubsub 'variant-change' hook misses.
  // Debounced full-page rescan; the engine only rewrites text nodes, so a rescan
  // never adds element nodes and can't retrigger this observer (no loop).
  var t = null;
  // The theme updates input[name="id"] on variant change but leaves the
  // product-info data-variant-id stale. Sync it so the engine matches the
  // correct testProduct (matters when variants have different test prices).
  function syncProductInfoVariants() {
    document.querySelectorAll('product-info[data-product-id]').forEach(function (pi) {
      var input = pi.querySelector('input[name="id"]');
      var vid = input && input.value;
      if (vid) pi.setAttribute('data-variant-id', String(vid));
    });
  }
  // Throttled to avoid storms / re-entrancy. The engine only rewrites text
  // nodes, so a rescan never adds element nodes and can't retrigger the price
  // branch of the observer (no loop) — the throttle is just belt-and-suspenders.
  var lastRescan = 0;
  function rescan() {
    var now = Date.now();
    if (now - lastRescan < 50) return;
    lastRescan = now;
    syncProductInfoVariants();
    var mgr = getManager();
    if (mgr && typeof mgr.updatePricesOnCurrentPage === 'function') {
      try { mgr.updatePricesOnCurrentPage(); } catch (_) {}
    }
  }
  function schedule() { clearTimeout(t); t = setTimeout(rescan, 150); }
  var PRICE_SEL = '.price, .price-item--sale, .price-item--regular, .upsell-price, .upsell-compare-price';
  function matchesSel(n, sel) {
    if (n.nodeType !== 1) return false;
    if (n.matches && n.matches(sel)) return true;
    return typeof n.querySelector === 'function' && n.querySelector(sel) !== null;
  }
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (muts) {
      var priceMorph = false, cardAdded = false;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.hasAttribute && n.hasAttribute('data-product-id')) ||
              matchesSel(n, '[data-product-id]')) {
            cardAdded = true;
          } else if (matchesSel(n, PRICE_SEL)) {
            // A price block was re-rendered in place (PDP variant change). The
            // MutationObserver callback runs as a microtask BEFORE the browser
            // paints, so re-applying synchronously here prevents the original
            // price from flashing before the test price snaps back.
            priceMorph = true;
          }
        }
      }
      if (priceMorph) rescan();        // synchronous — beats paint, no flash
      else if (cardAdded) schedule();  // debounced — batches AJAX cards
    });
    function startObserver() {
      obs.observe(document.body, { childList: true, subtree: true });
    }
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver);
  }

  trySubscribe();
})();
